import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "./messages.i18n";
import { ReadOnlyField } from "@components/common/form/readonly-field";
import FeaturesSelector from "@components/admin/admin-actions/admin-actions-forms/add-feature/FeatureSelector";
export const EditFeatureAccessFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        action: yup
            .array()
            .min(1, intl.formatMessage(messages.featureActionRequired))
            .required(intl.formatMessage(messages.featureActionRequired)),
    });
};
export const FeatureAccessFormInitialValues = {
    userName: "",
    // @ts-ignore
    action: [],
};
export const EditFeatureAccessFormFields = () => {
    const intl = useIntl();
    return {
        user: [
            {
                id: "organization.name",
                label: intl.formatMessage(messages.featureOrganization),
                placeholder: intl.formatMessage(messages.featureOrganization),
                component: ReadOnlyField,
                columns: 12,
                required: false,
            },
            {
                id: "community.name",
                label: intl.formatMessage(messages.featureCommunity),
                placeholder: intl.formatMessage(messages.featureCommunity),
                component: ReadOnlyField,
                columns: 12,
                required: false,
            },
            {
                id: "userName",
                label: intl.formatMessage(messages.featureUser),
                placeholder: intl.formatMessage(messages.featureUser),
                component: ReadOnlyField,
                columns: 12,
                required: false,
            },
        ],
        actions: [
            {
                id: "action",
                label: intl.formatMessage(messages.featureAction),
                placeholder: intl.formatMessage(messages.featureAction),
                component: FeaturesSelector,
                required: true,
                columns: 12,
            },
        ],
    };
};
